import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

import { PageBody } from "../PageBody";
import { Input } from "../../atoms/Input";
import { Label } from "../../atoms/Label";
import { Typography } from "../../atoms/Typography";
import { Snackbar } from "../../atoms/Snackbar";
import { Button } from "../../atoms/Button";
import { ConfirmModal } from "../../../containers/organisms/modal/ConfirmModal";
import { openModal, closeModal } from "../../../graphql/local-mutations";

import { defaultTheme } from "../../themes";
import { ValidationErrors } from "../../../types";
import okIcon from "../../../assets/icons/ok.png";
import errorIcon from "../../../assets/icons/alert.png";

/**
 * メールアドレス変更ページ
 */

export type HtPatient = {
  id: string;
  email?: string;
};

export type ValidatingForm = {
  proposedEmail: string;
};

export type UpdateEmailAddressPageProps = {
  htPatient: HtPatient;
  onUpdateEmailAddressClick: (email: string) => void;
  validationErrors: ValidationErrors<ValidatingForm>;
  setProposedEmail: (email: string) => void;
  proposedEmail: string;
  isFormValid: boolean;
  processing: boolean;
  snackBar: {
    type: "ok" | "error";
    message: string;
    isOpen: boolean;
    close: () => void;
  } | null;
  onCancelButtonClick: () => void;
  isOpen: boolean;
};

const ContentWrapper = styled.div`
  padding: 20px 40px;
  display: flex;
  flex-wrap: wrap;
`;

const ItemWrapper = styled.div<{ width?: string; marginBottom?: string }>`
  ${(props) => props.marginBottom && `margin-bottom: ${props.marginBottom}`};
  ${(props) => props.width && `width: ${props.width}`};
  padding: 0 30px 5px 0;
`;

const ButtonWrapper = styled.div<{ marginTop?: string; width?: string }>`
  ${(props) => props.marginTop && `margin-top: ${props.marginTop}`};
  width: ${(props) => props.width || "214px"};
  height: 44px;
`;

export function UpdateEmailAddressPage({
  htPatient,
  onUpdateEmailAddressClick,
  processing,
  validationErrors,
  proposedEmail,
  setProposedEmail,
  isFormValid,
  snackBar = null,
  onCancelButtonClick,
  isOpen,
}: UpdateEmailAddressPageProps) {
  return (
    <>
      <PageBody
        title={"メールアドレス変更"}
        buttonTitle="中止"
        buttonType="danger"
        buttonOutline
        buttonIcon={
          <FontAwesomeIcon icon={faTimes} color={defaultTheme.colors.caution} />
        }
        onButtonClick={() => {
          onCancelButtonClick();
        }}
      >
        <>
          <ContentWrapper>
            <ItemWrapper width="100%">
              <Label text={"変更前メールアドレス"} margin="0 0 7px 0" />
              <p>{htPatient.email || "なし"}</p>
            </ItemWrapper>
          </ContentWrapper>
          <ContentWrapper>
            <Label text={"変更後メールアドレス"} margin="0 0 7px 0" />
            <ItemWrapper width="100%">
              <Input
                onChange={(e) => setProposedEmail(e.target.value)}
                value={proposedEmail}
                error={!validationErrors.proposedEmail.isValid}
                errorMessages={validationErrors.proposedEmail.message}
              />
            </ItemWrapper>
            <ButtonWrapper width="334px">
              <Button
                onClick={() => openModal("confirmInput")}
                disabled={processing || !isFormValid}
                buttonType={"primary"}
              >
                <Typography size={1}>変更</Typography>
              </Button>
            </ButtonWrapper>
          </ContentWrapper>
        </>
      </PageBody>
      <ConfirmModal
        isOpen={isOpen}
        value={proposedEmail}
        isLoading={processing}
        title={"メールアドレスを以下に変更してもよろしいですか？"}
        actionLabel="変更"
        cancelLabel="キャンセル"
        onChangeClick={() => onUpdateEmailAddressClick(proposedEmail)}
        closeModal={() => closeModal("confirmInput")}
      />
      {!!snackBar && (
        <Snackbar
          isOpen={snackBar.isOpen}
          icon={
            <img
              src={snackBar.type === "ok" ? okIcon : errorIcon}
              width="18"
              height="18"
              alt={snackBar.type}
            />
          }
          text={snackBar.message}
          close={snackBar.close}
        />
      )}
    </>
  );
}
